

import { BASE_URL } from "../config";



export const AllocateLeavesForEmployee = async (empId, year, user) => {
  try {
    const response = await fetch(
      `${BASE_URL}/leave/allocate/${empId}?year=${year}&user=${user}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to allocate leave");
    }

    const data = await response.json(); 
    console.log("Updated Employee:", data);
    return data;

  } catch (error) {
    console.error("Error allocating leave:", error);
    alert("Failed to allocate leave.");
  }
};

export const AllocateLeavesForAll = async (year, user) => {
  try {
    const response = await fetch(
      `${BASE_URL}/leave/allocate/all?year=${year}&user=${user}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to allocate leave");
    }

    const data = await response.json(); // use JSON instead of text
    console.log("Updated Employee:", data);

    return data;
  } catch (error) {
    console.error("Error allocating leave:", error);
    alert("Failed to allocate leave ❌");
  }
};


export const getAllLeaves = async () => {
  try {
    const response = await fetch(`${BASE_URL}/leave/allocate`);
    if (!response.ok) {
      throw new Error("Failed to fetch leaves");
    }
    console.log("Fetched leaves:", response);
    return await response.json();
  } catch (error) {
    console.error("Error fetching leaves:", error);
    throw error;
  }
};


export const getBalanceLeaves = async (year) => {
  try {
    const response = await fetch(`${BASE_URL}/leave/balance/${year}`);
    if (!response.ok) {
      throw new Error("Failed to fetch balance leaves");
    }

    const data = await response.json();   // Parse JSON first
    console.log("Fetched balance leaves:", data);  // Log actual data
    return data;
  } catch (error) {
    console.error("Error fetching balance leaves:", error);
    throw error;
  }
};


export const getLeaveDetailsForEmp = async (employeeCode, year, month) => {
  try {
    // Build query params conditionally
    const queryParams = new URLSearchParams({ employeeCode, year });

    if (month) {
      queryParams.append("month", month);
    }

    const response = await fetch(`${BASE_URL}/leave/details?${queryParams}`);

    if (!response.ok) {
      throw new Error("Failed to fetch leave details");
    }

    const data = await response.json();
    console.log("Fetched leave details:", data);
    return data;
  } catch (error) {
    console.error("Error fetching leave details:", error);
    throw error;
  }
};


export const applyLeave = async (leaveData) => {
  console.log("Payload sent to backend:", leaveData); 
  try {
    const response = await fetch(`${BASE_URL}/leave/apply`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(leaveData),
    });

    const data = await response.json();

    if (!response.ok) {
      // throw new Error("Failed to apply leave");
      const message = data?.error || data?.message || "Failed to apply leave";
      throw new Error(message);
    }

    console.log("Leave Applied:", data);
    return data;
  } catch (error) {
    console.error("Error applying leave:", error);
    // alert("Failed to apply leave");
    alert(error.message || "Failed to apply leave");
  }
};


export const GetBalanceLeaveByLeaveTypeId = async (employeeCode, leavetypeId, year) => {
  try {
    const response = await fetch(`${BASE_URL}/leave/balance-leavetype?employeeCode=${employeeCode}&leaveTypeId=${leavetypeId}&year=${year}`);
    if (!response.ok) {
      throw new Error("Failed to fetch balance leaves");
    }

    const data = await response.json();   // Parse JSON first
    console.log("Fetched balance leaves:", data);  // Log actual data
    return data;
  } catch (error) {
    console.error("Error fetching balance leaves:", error);
    throw error;
  }
};


export const getLeaveApplications = async () => {
  try {
    const response = await fetch(`${BASE_URL}/leave/get-leave-application`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data; // returns your array of leave applications
  } catch (error) {
    console.error("Error fetching leave applications:", error);
    throw error;
  }
};


export const updateLeaveStatus = async (leaveAppID, status, approverID, trUser) => {
  try {
    const response = await fetch(`${BASE_URL}/leave/update-leave-status`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        leaveAppID,
        status,
        approverID,
        trUser,
      }),
    });

    // Check if response has content
    const text = await response.text();
    let data = {};
    if (text) {
      data = JSON.parse(text);
    }

    if (!response.ok || (data.status !== undefined && !data.status)) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return data; // { status: true, message: "..." } or empty object
  } catch (error) {
    console.error(`Error updating leave status for ${leaveAppID}:`, error);
    throw error;
  }
};

export const getAllAppliedLeaves = async (employeeCode) => {
  try{
    const response = await fetch(`${BASE_URL}/leave/track/${employeeCode}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching applied leave applications", error);
  }
}



export const handleWithdraw = async (leaveAppID, employeeCode) => {
  try {

    const response = await fetch(`${BASE_URL}/leave/cancel-leave`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        leaveAppID,
        employeeCode, // employeeCode
        trUser: employeeCode,   //backend expects trUser
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to withdraw leave");
    }

    return await response.json(); // return API result to component
  } catch (error) {
    console.error("Error withdrawing leave:", error);
    throw error;
  }
};


export const getLeaveReport = async (month, year) => {
  try {
    const response = await fetch(`${BASE_URL}/leave/leavereport?month=${month}&year=${year}`);
    
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "Failed to fetch leave details");
    }
    
    return data;
    
  } catch (error) {
    console.error("Error fetching leave details:", error);
    throw error;
  }
}

